import { render, staticRenderFns } from "./itemLevel.vue?vue&type=template&id=37c93656&"
import script from "./itemLevel.vue?vue&type=script&lang=js&"
export * from "./itemLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports